// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"6bf64e81","348":"41a45f14","571":"e53a1dfe","924":"f87566be"}[chunkId] + ".chunk.js";
};